// A short message at the bottom of the screen ("저장했습니다").
import { useEffect, useSyncExternalStore } from 'react'

let current: { id: number; text: string } | null = null
let nextId = 1
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) l()
}

export function showToast(text: string): void {
  current = { id: nextId++, text }
  emit()
}

export function Toast() {
  const t = useSyncExternalStore(
    (l) => {
      listeners.add(l)
      return () => listeners.delete(l)
    },
    () => current,
  )
  useEffect(() => {
    if (!t) return
    const timer = setTimeout(() => {
      if (current?.id === t.id) {
        current = null
        emit()
      }
    }, 2500)
    return () => clearTimeout(timer)
  }, [t])
  return (
    <div className="toast-area" role="status" aria-live="polite">
      {t && (
        <div key={t.id} className="toast">
          {t.text}
        </div>
      )}
    </div>
  )
}
